import Products from "./index";
import ProductDetail from "./_id";

// import middlewares
export default [
  {
    path: "/solopress-products",
    component: Products,
    name: "Solopress Products",
  },
  {
    path: "/solopress-products/details/:id",
    component: ProductDetail,
    name: "Solopress Product Details",
  }
];
